exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e063ecee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/globalWebsite/addEditGlobalWebsiteGroup.vue
// module id = 1133
// module chunks = 0